import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import './Navbar.css'
import Dropdown from './Dropdown'
import { MenuAboutItems } from './MenuItems'
import Icon from '.././images/icon.svg'

const Navbar = () => {
  const [click, setClick] = useState(false)

  const handleClick = () => setClick(!click)
  const closeMobileMenu = () => setClick(false)

  return (
    <>
      <nav className='navbar'>
        <Link to='/' className='navbar-logo'>
          <div className='navbar-logo-container'>
            <img src={Icon} alt='MPULE Institute' className='header-icon' />
            <div className='nav-title'>
              <h1 className='mpule'>MPULE</h1>
              <h1 className='foundation'>Foundation</h1>
            </div>
          </div>
        </Link>
        <div className='menu-icon' onClick={handleClick}>
          <i className={click ? 'fas fa-times' : 'fas fa-bars'} />
        </div>
        <ul className={click ? 'nav-menu active' : 'nav-menu'}>
          <li className='nav-item'>
            <div className='nav-links-container'>
              <Link to='/about' className='nav-links' onClick={closeMobileMenu}>
                About Us
              </Link>
              <div className='nav-caret'>
                <i className='fas fa-caret-down' onClick={handleClick} />
                {click && <Dropdown menuitems={MenuAboutItems} />}
              </div>
            </div>
          </li>
          <li className='nav-item'>
            <Link
              to='/solution'
              className='nav-links'
              onClick={closeMobileMenu}
            >
              Solution
            </Link>
          </li>
          <li className='nav-item'>
            <Link
              to='/insights'
              className='nav-links'
              onClick={closeMobileMenu}
            >
              Insights
            </Link>
          </li>
          <li className='nav-item'>
            <Link
              to='/partners'
              className='nav-links'
              onClick={closeMobileMenu}
            >
              Partners
            </Link>
          </li>
          <li className='nav-item'>
            <Link to='/contact' className='nav-links' onClick={closeMobileMenu}>
              Contact
            </Link>
          </li>
        </ul>
      </nav>
    </>
  )
}

export default Navbar
